import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isIE11Browser } from '../../Util/CommonUtils';

import './StickyNav.scss';

const StickyNav = (props) => {
  const [isSticky, setSticky] = useState(false);
  const [isStickySecodary, setStickySecodary] = useState(false);
  const [topOffsetClass, setTopOffsetClass] = useState('top-offset-60');
  const mainReducer = useSelector((state) => state.mainReducer);
  const [scrollOrClick, setScrollOrClick] = useState(true); // to capture click or scroll
  const stickyNavRef = useRef();
  const navBodyRef = useRef();

  const getElementOffsetTop = (element, offsetTopAccumulator = 0) => {
    if (element.offsetParent !== null) {
      return getElementOffsetTop(element.offsetParent, offsetTopAccumulator + element.offsetTop);
    }
    return offsetTopAccumulator;
  };

  const scrollTo = (index) => {
    const element = navBodyRef.current.getElementsByClassName(props.navBodyClass)[index];
    const headerHeight = document.getElementById('headerInfo').offsetHeight;
    const stickyHeight = stickyNavRef.current.offsetHeight;
    let scrollToElement = getElementOffsetTop(element) - headerHeight - stickyHeight;
    if (!isSticky) {
      scrollToElement -= 100;
    }
    isIE11Browser()
      ? window.scroll(0, scrollToElement)
      : window.scroll({ top: scrollToElement, behaviour: 'smooth' });
  };

  const navLinkAction = (navData, index, event) => {
    if (navData.href) {
      return true;
    }
    switch (navData.Type) {
      case 'SCROLL':
      default:
        event.preventDefault();
        scrollTo(index);
        break;
    }
    return false;
  };

  useEffect(() => {
    const stickyOffset = stickyNavRef.current.offsetTop;
    let currentPageOffset = window.pageYOffset;

    function fixStickyNav() {
      if (window.pageYOffset > stickyOffset) {
        setScrollOrClick(false); //setting off
        if (window.pageYOffset > currentPageOffset) {
          setStickySecodary(false);
          if (
            !!mainReducer.pageData.promotionMessage &&
            mainReducer.pageData.promotionMessage !== ''
          ) {
            setTopOffsetClass('top-offset-120');
          } else {
            setTopOffsetClass('top-offset-60');
          }
        } else {
          setStickySecodary(true);
          if (
            !!mainReducer.pageData.promotionMessage &&
            mainReducer.pageData.promotionMessage !== ''
          ) {
            setTopOffsetClass('top-offset-180');
          } else {
            setTopOffsetClass('top-offset-120');
          }
        }
        setSticky(true);
      } else {
        setSticky(false);
        setStickySecodary(false);
      }
      currentPageOffset = window.pageYOffset;
    }

    window.addEventListener('scroll', fixStickyNav);

    return () => {
      window.removeEventListener('scroll', fixStickyNav);
    };
  }, [mainReducer.pageData.promotionMessage, stickyNavRef]);

  useEffect(() => {
    if (!!mainReducer.pageData.promotionMessage && mainReducer.pageData.promotionMessage !== '') {
      setTopOffsetClass('top-offset-120');
    }
  }, [mainReducer.pageData.promotionMessage]);

  return (
    <div>
      <div
        className={`stickyNav ${isSticky ? ' sticky-header-active' : ''} ${
          isStickySecodary ? ' sticky-header-secondary' : ''
        } ${topOffsetClass} ${props?.navigationData?.[0]?.customCss && !isSticky ? 'container-center-lg':'' }`}
        ref={stickyNavRef}
      >
        <div className="text-align-center">
          {props.navigationData.map((navData, index) => {
            if (navData.NavName) {
              return (
                <a
                  className="nav_header_link"
                  href={navData.href ? navData.href : '#'}
                  onClick={(event) =>{ 
                    navLinkAction(navData, index, event)
                     setScrollOrClick(false); 
                    }}
                  key={index}
                >
                  <p className={` 
                    ${ props?.navigationData?.[0]?.customCss    // for secure-prodcuts screen only
                    && scrollOrClick                             // only get visible at intialy
                    && index === 0                              // for first element
                    ? 'custom-first' : ''}`} 
                    data-bold-text={navData.NavName}>
                    {navData.NavName}
                  </p>
                </a>
              );
            }
            return null;
          })}
        </div>
      </div>
      <div ref={navBodyRef} className="stickyNavBody">
        {props.children}
      </div>
    </div>
  );
};

StickyNav.propTypes = {
  children: PropTypes.element,
  navigationData: PropTypes.array,
};

export default StickyNav;
